import React from 'react';
import { Container, Accordion } from 'react-bootstrap';
import '../../style/LandingPageStyle.css';
import Header from './Header';
import Footer from './footer';

const examples = [
    {
        college: "Engenharia Civil",
        tasks: [
            "Avaliação gratuita de condições de segurança de edifícios de associações ou habitações sociais.",
            "Apoio no desenho e melhoria de acessibilidades (rampas, percursos, sanitários adaptados).",
        ],
    },
    {
        college: "Engenharia Eletrotécnica",
        tasks: [
            "Instalação ou melhoria de iluminação eficiente em centros comunitários.",
            "Apoio à instalação de sistemas solares simples em associações ou escolas.",
        ],
    },
    {
        college: "Engenharia Mecânica",
        tasks: [
            "Reparação e manutenção de equipamentos mecânicos em IPSS (cadeiras de rodas, elevadores, sistemas AVAC).",
            "Otimização de processos simples (ex.: oficinas sociais, cooperativas).",
        ],
    },
    {
        college: "Engenharia Geológica e de Minas",
        tasks: [
            "Avaliação de riscos geotécnicos em pequenas infraestruturas comunitárias.",
            "Apoio em projetos de gestão sustentável de recursos geológicos locais.",
        ],
    },
    {
        college: "Engenharia Química e Biológica",
        tasks: [
            "Apoio na melhoria de processos de tratamento de água em comunidades pequenas.",
            "Formação básica sobre segurança química e ambiental em associações.",
        ],
    },
    {
        college: "Engenharia Naval e Oceânica",
        tasks: [
            "Apoio técnico a associações de pesca artesanal (segurança, manutenção).",
            "Monitorização e proteção de zonas costeiras e estuários.",
        ],
    },
    {
        college: "Engenharia Geoespacial",
        tasks: [
            "Criação de mapas digitais para ONGs (acessos, riscos, recursos).",
            "Apoio em projetos de ordenamento do território comunitário.",
        ],
    },
    {
        college: "Engenharia Agronómica",
        tasks: [
            "Apoio técnico a hortas comunitárias e escolares.",
            "Formação em boas práticas agrícolas sustentáveis.",
        ],
    },
    {
        college: "Engenharia Florestal",
        tasks: [
            "Planeamento de ações de reflorestação e gestão de espaços verdes.",
            "Apoio técnico na prevenção de incêndios rurais.",
        ],
    },
    {
        college: "Engenharia de Materiais",
        tasks: [
            "Apoio na seleção de materiais sustentáveis para pequenas obras sociais.",
            "Análise de degradação de materiais em edifícios comunitários.",
        ],
    },
    {
        college: "Engenharia Informática",
        tasks: [
            "Desenvolvimento de sites simples ou plataformas digitais para ONGs.",
            "Formação em competências digitais básicas para associações e voluntários.",
        ],
    },
    {
        college: "Engenharia do Ambiente",
        tasks: [
            "Apoio a projetos de gestão de resíduos em comunidades locais.",
            "Monitorização simples da qualidade da água ou do ar.",
        ],
    },
    {
        college: "Engenharia e Gestão Industrial",
        tasks: [
            "Melhoria da organização e eficiência de associações sem fins lucrativos.",
            "Apoio na gestão de projetos de voluntariado.",
        ],
    },
    {
        college: "Engenharia Alimentar",
        tasks: [
            "Apoio técnico a cozinhas sociais (segurança alimentar).",
            "Otimização de processos de conservação e desperdício alimentar.",
        ],
    },
    {
        college: "Engenharia Aeronáutica e Espacial",
        tasks: [
            "Apoio educativo em clubes de ciência e STEM (drones, espaço).",
            "Uso de drones para apoio ambiental ou proteção civil (ex.: mapeamento).",
        ],
    },
    {
        college: "Engenharia Biomédica e Bioengenharia",
        tasks: [
            "Manutenção e adaptação de equipamentos médicos simples.",
            "Desenvolvimento de ajudas técnicas de baixo custo para pessoas com deficiência.",
        ],
    },
    {
        college: "Engenharia de Segurança e Qualidade",
        tasks: [
            "Avaliação de riscos e planos de segurança em associações e eventos.",
            "Implementação de boas práticas de qualidade e segurança em IPSS.",
        ],
    },
];

const ExamplesPage = () => {
    return (
        <>
            <Header />
            
            {/* Removi a classe 'about-container' para garantir que os elementos não são forçados a alinhar lado-a-lado */}
            <Container style={{ marginTop: '150px', marginBottom: '80px', minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                
                {/* Título */}
                <h2 style={{ textAlign: 'center', marginBottom: '10px', color: '#009fe3', fontWeight: 'bold' }}>
                    Exemplos de Desafios
                </h2>
                
                {/* Descrição */}
                <p style={{ textAlign: 'center', marginBottom: '40px', color: '#666' }}>
                    Exemplos de tarefas que as associações podem submeter, organizadas por Colégio de Engenharia.
                </p>

                {/* Acordeão - Forçado a ter uma largura e a centrar-se na página */}
                <div style={{ width: '100%', maxWidth: '800px' }}>
                    <Accordion defaultActiveKey="0">
                        {examples.map((item, index) => (
                            <Accordion.Item eventKey={index.toString()} key={index} style={{ marginBottom: '15px' }}>
                                <Accordion.Header>
                                    <strong>{index + 1}. {item.college}</strong>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <ul style={{ paddingLeft: '20px', margin: 0, color: '#444' }}>
                                        {item.tasks.map((task, i) => (
                                            <li key={i} style={{ marginBottom: '8px' }}>
                                                {task}
                                            </li>
                                        ))}
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                </div>
                
            </Container>

            <Footer />
        </>
    );
};

export default ExamplesPage;
